import request from '@/utils/request'
import qs from 'qs'

//进去页面获取会员个人资料请求
export function personal(query) {
    return request({
        url: '/store/api/center/get',
        method: 'get',
        params: query,
    })

}
// 获取大洲
export function getContinent(query) {
    return request({
        url: '/store/api/address/continent',
        method: 'get',
        params: query,
    })

}
// 选择国家
export function getCountry(query) {
    return request({
        url: '/store/api/address/country',
        method: 'post',
        data: qs.stringify(query),
    })

}
//获取地址列表
export function getAdress(query) {
    return request({
        url: '/store/api/address/getList',
        method: 'get',
        data: qs.stringify(query),
    })

}
//重新设置新地址
export function resetAdress(query) {
    // console.log('更新地址参数', qs.stringify(query))
    return request({
        url: '/store/api/address/set',
        method: 'post',
        data: qs.stringify(query),
    })

}

//删除地址请求
export function deleteAdr(query) {
    // console.log('删除参数', qs.stringify(query))
    console.log('删除', query)
    return request({
        url: '/store/api/address/del',
        method: 'delete',
        data: qs.stringify(query),
    })
}

//修改会员资料的请求

export function resetMsg(query) {
    return request({
        url: '/store/api/center/edit',
        method: 'post',
        data: qs.stringify(query),
    })

}
// 修改密码
export function changePass(query) {
    return request({
        url: '/store/api/center/editPassword',
        method: 'post',
        data: qs.stringify(query),
    })

}
export function reset(query) {
    return request({
        url: '/store/api/center/repassword',
        method: 'post',
        data: qs.stringify(query),
    })

}


// WEBPACK FOOTER //
// ./src/api/personal.js